import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

const client = axios.create({ baseURL: API });

export const api = {
  listWheels: () => client.get("/wheels").then((r) => r.data),
  getWheel: (slug) => client.get(`/wheels/${slug}`).then((r) => r.data),
  updateWheel: (slug, data) => client.put(`/wheels/${slug}`, data).then((r) => r.data),
  addItem: (slug, data) => client.post(`/wheels/${slug}/items`, data).then((r) => r.data),
  updateItem: (id, data) => client.put(`/items/${id}`, data).then((r) => r.data),
  duplicateItem: (id) => client.post(`/items/${id}/duplicate`).then((r) => r.data),
  deleteItem: (id) => client.delete(`/items/${id}`).then((r) => r.data),
  reorderItems: (slug, ids) => client.post(`/wheels/${slug}/reorder`, { ids }).then((r) => r.data),

  listObjectives: (difficulty) =>
    client.get("/objectives", { params: difficulty ? { difficulty } : {} }).then((r) => r.data),
  addObjective: (data) => client.post("/objectives", data).then((r) => r.data),
  updateObjective: (id, data) => client.put(`/objectives/${id}`, data).then((r) => r.data),
  duplicateObjective: (id) => client.post(`/objectives/${id}/duplicate`).then((r) => r.data),
  deleteObjective: (id) => client.delete(`/objectives/${id}`).then((r) => r.data),

  spin: (slug) => client.post(`/spin/${slug}`).then((r) => r.data),
  drawObjective: (difficulty) => client.post(`/objective/${difficulty}`).then((r) => r.data),
  overlayHide: () => client.post("/overlay/hide").then((r) => r.data),
  overlayReset: () => client.post("/overlay/reset").then((r) => r.data),
  simulateSub: (username) => client.post("/simulate-sub", { username }).then((r) => r.data),

  history: (params) => client.get("/history", { params }).then((r) => r.data),
  clearHistory: () => client.delete("/history").then((r) => r.data),

  getSettings: () => client.get("/settings").then((r) => r.data),
  saveSettings: (data) => client.put("/settings", data).then((r) => r.data),
  generateKey: () => client.post("/streamdeck/generate-key").then((r) => r.data),
  revokeKey: () => client.post("/streamdeck/revoke-key").then((r) => r.data),

  exportConfig: () => client.get("/export").then((r) => r.data),
  importConfig: (data) => client.post("/import", data).then((r) => r.data),
  integrationsStatus: () => client.get("/status/integrations").then((r) => r.data),
};
